// removed by extract-text-webpack-plugin
module.exports = {"app":"app__2Pnj5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/App.css
// module id = 1582
// module chunks = 0